<template>
	<b-container fluid class="page">
		<Header />
		<section class="mh-main">
			<b-container id="main" fluid>
				<Menu />
				<DashboardContent v-if="showDashboardContent" />
				<TimeClockContent v-if="showTimeClockContent" />
				<ScheduleContent v-if="showScheduleContent" />
				<TimeEntriesContent v-if="showTimeEntriesContent" />
				<PlansContent v-if="showPlansContent" />
				<TimeOffContent v-if="showTimeOffContent" />
				<AccidentsIncidentsContent v-if="showAccidentsIncidentsContent" />
				<CustomersContent v-if="showCustomersContent" />
				<DocumentsContent v-if="showDocumentsContent" />
				<DashboardClientContent v-if="showDashboardClientContent" />
				<InvoicesClientContent v-if="showInvoicesClientContent" />
				<AvailableShiftsContent v-if="showAvailableShiftsContent" />
			</b-container>
		</section>
	</b-container>
</template>

<script>
	import Menu from "./partials/Menu"
	import Header from "./partials/Header"
	import DashboardContent from "./DashboardContent"
	import TimeClockContent from "./TimeClockContent"
	import ScheduleContent from "./ScheduleContent"
	import TimeEntriesContent from "./TimeEntriesContent"
	import PlansContent from "./PlansContent"
	import TimeOffContent from "./TimeOffContent"
	import AccidentsIncidentsContent from "./AccidentsIncidentsContent"
	import CustomersContent from "./CustomersContent"
	import DocumentsContent from "./DocumentsContent"
	import DashboardClientContent from "./DashboardClientContent"
	import InvoicesClientContent from "./InvoicesClientContent"
	import AvailableShiftsContent from "./AvailableShiftsContent"

    export default {
        name: 'ContentPage',
		components: {
			Menu,
			Header,
			DashboardContent,
			TimeClockContent,
			ScheduleContent,
			TimeEntriesContent,
			PlansContent,
			TimeOffContent,
			AccidentsIncidentsContent,
			CustomersContent,
			DocumentsContent,
			DashboardClientContent,
			InvoicesClientContent,
			AvailableShiftsContent
		},
		computed: {
			showDashboardContent() { return this.$store.state.Content.content == "DashboardContent" },
			showTimeClockContent() { return this.$store.state.Content.content == "TimeClockContent" },
			showScheduleContent() { return this.$store.state.Content.content == "ScheduleContent" },
			showTimeEntriesContent() { return this.$store.state.Content.content == "TimeEntriesContent" },
			showPlansContent() { return this.$store.state.Content.content == "PlansContent" },
			showTimeOffContent() { return this.$store.state.Content.content == "TimeOffContent" },
			showAccidentsIncidentsContent() { return this.$store.state.Content.content == "AccidentsIncidentsContent" },
			showCustomersContent() { return this.$store.state.Content.content == "CustomersContent" },
			showDocumentsContent() { return this.$store.state.Content.content == "DocumentsContent" },
			showDashboardClientContent() { return this.$store.state.Content.content == "DashboardClientContent" },
			showInvoicesClientContent() { return this.$store.state.Content.content == "InvoicesClientContent" },
			showAvailableShiftsContent() { return this.$store.state.Content.content == "AvailableShiftsContent" }
		}
    }
</script>

<style scoped>
</style>